export const CircleInfo = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0013 1.66699C5.39893 1.66699 1.66797 5.39795 1.66797 10.0003C1.66797 14.6027 5.39893 18.3337 10.0013 18.3337C14.6037 18.3337 18.3346 14.6027 18.3346 10.0003C18.3346 5.39795 14.6037 1.66699 10.0013 1.66699ZM8.33464 9.16699C8.33464 8.82182 8.61446 8.54199 8.95964 8.54199H10.0013C10.3465 8.54199 10.6263 8.82181 10.6263 9.16699L10.6263 13.542C10.6263 13.8872 10.3465 14.167 10.0013 14.167C9.65613 14.167 9.3763 13.8872 9.3763 13.542L9.3763 9.79199H8.95964C8.61446 9.79199 8.33464 9.51217 8.33464 9.16699ZM10.0013 6.04199C9.65612 6.04199 9.3763 6.32181 9.3763 6.66699C9.3763 7.01217 9.65612 7.29199 10.0013 7.29199C10.3465 7.29199 10.6263 7.01217 10.6263 6.66699C10.6263 6.32181 10.3465 6.04199 10.0013 6.04199Z"
      fill="currentColor"
    />
  </svg>
)

export default CircleInfo
